import _ from "lodash";
import { push } from "connected-react-router";

import { checkAndRenewTokens, checkTokenError } from "./auth";
import { showErrorMessage, showSuccessMessage } from "./ui";
import { getMessageInfo, createMessage, editMessage } from "../../request";

//Редактирование формы сообщения
export const SET_MESSAGE_NAME = "Set message name";
export const SET_MESSAGE_TEXT = "Set message text";
export const SET_MESSAGE_TYPE = "Set message type";
export const TOGGLE_MSG_CLIENTS_ROLE = "Toggle message clients role";
export const TOGGLE_MSG_CONSULTANTS_ROLE = "Toggle message consultants role";

//Очистка формы сообщения
export const CLEAR_MESSAGE_FORM = "Clear message form";

//Создание сообщения
export const MESSAGE_CREATION_START = "Message creation start";
export const MESSAGE_CREATED_SUCCESSFULLY = "Message created successfully";
export const MESSAGE_CREATION_FAILED = "Failure during message creation";

//Загрузка информации о редактируемом сообщении
export const EDITING_MESSAGE_LOADING_START = "Editing message form loading start";
export const EDITING_MESSAGE_LOADED_SUCCESSFULLY = "Editing message form loaded successfully";
export const EDITING_MESSAGE_LOADING_FAILED = "Failure during editing message form load";

//Редактирование сообщения
export const MESSAGE_EDITING_START = "Message editing start";
export const MESSAGE_EDITED_SUCCESSFULLY = "Message edited successfully";
export const MESSAGE_EDITING_FAILED = "Failure during message editig";


//РЕДАКТИРОВАНИЕ ФОРМЫ СООБЩЕНИЯ

//Название сообщения
export const setMessageName = value => ({
  type: SET_MESSAGE_NAME,
  payload: { value }
});

//Текст сообщения
export const setMessageText = value => ({
  type: SET_MESSAGE_TEXT,
  payload: { value }
});

//Тип сообщения
export const setMessageType = value => ({
  type: SET_MESSAGE_TYPE,
  payload: { value }
});

//Роль сообщения
export const toggleMessageClientsRole = () => ({
  type: TOGGLE_MSG_CLIENTS_ROLE,
});

export const toggleMessageConsultantsRole = () => ({
  type: TOGGLE_MSG_CONSULTANTS_ROLE,
});

//Очистка формы сообщения
export const clearMessageForm = () => ({
  type: CLEAR_MESSAGE_FORM
});

//СОЗДАНИЕ СООБЩЕНИЯ
const startCreation = () => ({
  type: MESSAGE_CREATION_START
});

const creationSuccess = () => ({
  type: MESSAGE_CREATED_SUCCESSFULLY,
});

const creationFailure = () => ({
  type: MESSAGE_CREATION_FAILED,
});

export const createMessageAsync = () => {
  return async (dispatch, getState) => {
    dispatch(startCreation());
    await dispatch(checkAndRenewTokens());
    const currentState = getState();
    const message = currentState.editMessage.message;

    //Соберем массив ролей из чекбоксов
    message.role = [];
    if (message.clients && !message.consultants) message.role.push('client');
    else if (!message.clients && message.consultants) message.role.push('consultant');
    //Выбраны оба или не выбран не один чекбокс - доступны обе роли
    else message.role.push('client', 'consultant');

    const data = _.omit(message, ['id', 'clients', 'consultants']);

    try {
      const accessToken = localStorage.getItem("accessToken");
      await createMessage(accessToken, data);
    } catch (err) {
      dispatch(checkTokenError(err));
      dispatch(showErrorMessage('Ошибка при создании сообщения'));
      return dispatch(creationFailure());
    }
    dispatch(push('/messages'));
    dispatch(showSuccessMessage('Новое сообщение создано'));
    return dispatch(creationSuccess());

  };
};

//ЗАГРУЗКА ИНФОРМАЦИИ О РЕДАКТИРУЕМОМ СООБЩЕНИИ
const startLoading = () => ({
  type: EDITING_MESSAGE_LOADING_START
});

const loadSuccess = message => ({
  type: EDITING_MESSAGE_LOADED_SUCCESSFULLY,
  payload: { message },
}); 

const loadFailure = () => ({ 
  type: EDITING_MESSAGE_LOADING_FAILED,
});

//ЗАГРУЗКА ИНФОРМАЦИИ О СООБЩЕНИИ
export const getEditingMessageAsync = msgId => {
  return async (dispatch) => {
    dispatch(startLoading());
    await dispatch(checkAndRenewTokens());
    let message; 

    try {
      const accessToken = localStorage.getItem("accessToken");
      message = await getMessageInfo(accessToken, msgId);
    } catch (err) {
      dispatch(checkTokenError(err));
      dispatch(showErrorMessage('Ошибка при загрузке информации о сообщении'));
      return dispatch(loadFailure());
    }
    return dispatch(loadSuccess(message));
  };
};

//РЕДАКТИРОВАНИЕ СООБЩЕНИЯ
const startEditing = () => ({
  type: MESSAGE_EDITING_START
});

const editingSuccess = () => ({
  type: MESSAGE_EDITED_SUCCESSFULLY,
});

const editingFailure = () => ({
  type: MESSAGE_EDITING_FAILED,
});

export const editMessageAsync = msgId => {
  return async (dispatch, getState) => {
    dispatch(startEditing());
    await dispatch(checkAndRenewTokens());
    const currentState = getState();
    let message = currentState.editMessage.message;

    //Соберем массив ролей из чекбоксов
    message.role = [];
    if (message.clients && !message.consultants) message.role.push('client');
    else if (!message.clients && message.consultants) message.role.push('consultant');
    //Выбраны оба или не выбран не один чекбокс - доступны обе роли
    else message.role.push('client', 'consultant');

    const data = _.omit(message, ['clients', 'consultants']);

    try {
      const accessToken = localStorage.getItem("accessToken");
      await editMessage(accessToken, data, msgId);
    } catch (err) {
      dispatch(checkTokenError(err));
      dispatch(showErrorMessage('Ошибка при редактировании сообщения'));
      return dispatch(editingFailure());
    }
    dispatch(push('/message/' + msgId));
    dispatch(showSuccessMessage('Сообщение отредактировано'));
    return dispatch(editingSuccess());
  };
};